import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {initialize, reduxForm, Field, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import * as authActions from '../actions/auth';
import FlashMessage from '../components/FlashMessage';
import TextInput from '../components/Form/TextInput';
import CheckboxInput from '../components/Form/CheckboxInput';
import validate from '../validators/forms/ask';
import AppBlock from '../components/AppBlock';
import Title from '../components/Form/Title';
import TextPage from './TextPage';
import BackButton from '../components/BackButton';

const FORM_NAME = 'ask-form';

class AuthAsk extends Component {
  constructor(props) {
    super(props);

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    const {
      dispatch,
      auth: {
        ask: {promo_email_agreement}
      }
    } = this.props;
    const initialFormData = {
      promo_email_agreement: true
    };

    if (promo_email_agreement) {
      dispatch(initialize('ask-form', initialFormData));
    }
  }

  handleFormSubmit(values) {
    authActions.askAsync(this.props.dispatch, values, this.props.location.query, this.props.xl);
  }

  successMessage() {
    const {
      xl: {isIFrame},
      intl,
      email
    } = this.props;
    return (
      <div className="block-content">
        <div className="content-message">
          <div className="message">{intl.formatMessage({id: 'auth-ask.check_email'}, {email})}</div>

          <BackButton isIFrame={isIFrame} />
        </div>
      </div>
    );
  }

  render() {
    const {
      intl,
      auth,
      handleSubmit,
      auth: {
        ask: {fields}
      }
    } = this.props;
    const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

    return (
      <Fragment>
        {auth.ask.needConfirm === false ? (
          <AppBlock>
            <Title title={intl.messages['auth-ask.title']} />

            <div className="block-content">
              {auth.ask.error !== null && <FlashMessage type="error" message={auth.ask.error} />}

              <form autoComplete="off" onSubmit={handleSubmit(this.handleFormSubmit)}>
                {fields
                  .filter(field => field !== 'promo_email_agreement')
                  .map((field, index) => (
                    <Field
                      component={TextInput}
                      key={index}
                      name={field}
                      type="text"
                      label={capitalizeFirstLetter(field)}
                      required="true"
                      icon={field}
                      disabled={auth.ask.loading}
                    />
                  ))}

                {auth.ask.promo_email_agreement && (
                  <CheckboxInput
                    name="promo_email_agreement"
                    label={intl.messages['form.promo_email']}
                    disabled={auth.ask.loading}
                  />
                )}

                <button
                  type="submit"
                  className="form-button button-with-bg"
                  disabled={auth.ask.loading}
                >
                  {auth.ask.loading ? intl.messages['form.loading'] : intl.messages['form.submit']}
                </button>
              </form>
            </div>
          </AppBlock>
        ) : (
          <TextPage content={this.successMessage()} title={intl.messages['auth-ask.title']} />
        )}
      </Fragment>
    );
  }
}

AuthAsk.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  intl: PropTypes.object,
  xl: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    ...state,
    ...validate(state.auth.ask.fields),
    email: formValueSelector(FORM_NAME)(state, 'email') || '',
    form: FORM_NAME
  };
}

export default injectIntl(connect(mapStateToProps)(reduxForm()(AuthAsk)));



// WEBPACK FOOTER //
// ./pages/Ask.jsx